import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getProducts(params = {}) {
        const query = new URLSearchParams(params).toString();
        return axios.get(`${API_URL}/pos/products?${query}`, { headers: authHeader() });
    },
    getClients() {
        return axios.get(`${API_URL}/pos/clients`, { headers: authHeader() });
    },
    createClient(data) {
        return axios.post(`${API_URL}/users`, data, { headers: authHeader() });
    },
    storeSale(data) {
        return axios.post(`${API_URL}/pos/sales`, data, { headers: authHeader() });
    },
};
